import { Temporal } from "@js-temporal/polyfill";
import React, { useState } from "react";


import "./WeekDaySelector2.css"


interface DayRepresentation {
    index: number,
    abbreviation: string,
    fullName: string
}

export const weekDaysStringMap2: { [key: number]: DayRepresentation } = {
    1: { index: 1, abbreviation: "L", fullName: "Lunes" },
    2: { index: 2, abbreviation: "M", fullName: "Martes" },
    3: { index: 3, abbreviation: "X", fullName: "Miércoles" },
    4: { index: 4, abbreviation: "J", fullName: "Jueves" },
    5: { index: 5, abbreviation: "V", fullName: "Viernes" },
    6: { index: 6, abbreviation: "S", fullName: "Sábado" },
    7: { index: 7, abbreviation: "D", fullName: "Domingo" },
};


export const getTimestampFromPlainDate = (plaindate: Temporal.PlainDate, timeZone: string = "UTC"): number => {
    // const plainDate = Temporal.PlainDate.from(dateString); // Convert to PlainDate
    const plainDateTime = plaindate.toPlainDateTime("00:00:00"); // Combine with a time
    const zonedDateTime = plainDateTime.toZonedDateTime(timeZone); // Convert to ZonedDateTime
    const instant = zonedDateTime.toInstant(); // Convert to Instant
    return instant.epochMilliseconds; // Get Unix timestamp in milliseconds
};






interface Props {
    initialDate: Temporal.PlainDate
    onActiveDayChanged?: (date: Temporal.PlainDate) => void
}





export function WeekDaySelector2({ initialDate = Temporal.PlainDate.from("2025-07-14"), onActiveDayChanged }: Props) {

    const computeDaysStartingFromSelectedIncludingIt = (selected: Temporal.PlainDate): Temporal.PlainDate[] => {

        const numDays = 7;
        let result = Array<Temporal.PlainDate>();

        result.push(selected);
        for (let i = 1; i < numDays; i++) {
            result.push(selected.add({ days: i }));
        }
        return result;
    };


    const toRenderDays = computeDaysStartingFromSelectedIncludingIt(initialDate);



    const [selectedDate, setSelectedDate] = useState(initialDate);


    const [activeWeek, setActiveWeek] = useState(toRenderDays);


    const handleClickedDay = (newDate: Temporal.PlainDate) => {
        setSelectedDate(newDate);
        if (onActiveDayChanged != null)
            onActiveDayChanged(newDate)
    };


    const getMonthsSplit = () => {
        for (let index = 0; index < activeWeek.length; index++) {
            const date = activeWeek[index];
            // Detect change of month
            if (index !== 0 && date.month !== activeWeek[index - 1].month) {
                return {
                    isSplitWeek: true,
                    whereSplit: index,
                    months: [activeWeek[index - 1].month, date.month]
                };
            }
        }

        return null;

    };

    const monthSplit = getMonthsSplit();


    return (<>


        {/* <div>
            Selected day {selectedDate.dayOfWeek} -  String: {weekDayToString(selectedDate.dayOfWeek)}
        </div> */}



        {/* Here I am displaying the important stuff */}
        <div className="WeekDisplay2">

            {activeWeek.map((oneDate, index, array) => {


                const isFirstItem = index == 0;
                const isLastItem = index == array.length - 1;
                const fancyBorderClass = isFirstItem ? " border-left " : isLastItem ? " border-right" : " ";

                const isSelectedDay = selectedDate == oneDate;
                const ifDaySelectedCss = isSelectedDay ? "selected-day" : "";

                const thisDateId = getTimestampFromPlainDate(oneDate);

                return (<>
                    {/* <span className="" key={getTimestampFromPlainDate(oneDate)}> */}
                    <span
                        key={thisDateId + "wd"}
                        className={"weekday-display hover-scaling " + ifDaySelectedCss}
                        onClick={() => handleClickedDay(oneDate)}>
                        {weekDaysStringMap2[oneDate.dayOfWeek].abbreviation}
                    </span>

                    {/* </span> */}

                    {/* <span key={thisDateId + "d"} className="monthday-display"> {oneDate.day} </span> */}


                    {/* If the data to display is in the same month - give different style to fractions of week */}
                    {/* {monthSplit?.isSplitWeek &&
                        <span
                            key={thisDateId + "ws"}
                            className={"month-display " + ((index < monthSplit.whereSplit) ? "A" : "B") + fancyBorderClass}>
                            <span className={"month-display-overlay "}> {(index == monthSplit.whereSplit - 1 || index == monthSplit.whereSplit) ? monthsStringMap[oneDate.month].slice(0, 3) : ""}</span>
                        </span>} */}

                    {/* {!monthSplit?.isSplitWeek && isFirstItem && <span

                        key={thisDateId + "wn"}
                        className={"month-display-full"}> {monthNumberToString(oneDate.month)} </span>} */}


                </>);
            })}




        </div>



        {/* <ul> {

            toRenderDays.map((oneDate, idx) => {
                return (<li key={getTimestampFromPlainDate(oneDate)}> {oneDate.day} {weekDaysStringMap[oneDate.dayOfWeek]}  {monthsStringMap[oneDate.month]}</li>)
            })}</ul> */}



    </>);
}
